var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.03 6.16H15.42V4.7C15.42 3.76 14.66 3 13.72 3H10.88C9.94 3 9.18 3.76 9.18 4.7V6.2H5.56C5.24 6.2 5 6.43 5 6.76C5 7.09 5.24 7.32 5.56 7.32H6.42V17.98C6.42 19.65 7.76 21 9.41 21H15.16C16.78 21 18.15 19.61 18.15 17.98V7.28H19.01C19.33 7.28 19.57 7.04 19.57 6.72C19.57 6.4 19.32 6.16 19.01 6.16H19.03ZM10.26 6.19V4.69C10.26 4.37 10.51 4.11 10.84 4.11H13.68C14 4.11 14.26 4.36 14.26 4.69V6.19H10.26ZM17.08 7.28V17.7H17.05V17.94C17.05 18.97 16.19 19.85 15.18 19.85H9.43C8.4 19.85 7.55 18.99 7.55 17.94V7.28H17.08Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3998 17.0204C10.7198 17.0204 10.9598 16.7904 10.9598 16.4604V10.6704C10.9598 10.3604 10.7098 10.1104 10.3998 10.1104C10.0798 10.1104 9.83984 10.3504 9.83984 10.6704V16.4604C9.83984 16.7804 10.0798 17.0204 10.3998 17.0204Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1616 17.0204C14.4816 17.0204 14.7216 16.7904 14.7216 16.4604V10.6704C14.7216 10.3504 14.4816 10.1104 14.1616 10.1104C13.8416 10.1104 13.6016 10.3504 13.6016 10.6704V16.4604C13.6016 16.7804 13.8416 17.0204 14.1616 17.0204Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/iconDelete.5ea7f7bea4df36a59c96e1ad4d5d63a6.svg";
export { ForwardRef as ReactComponent };